import React, { useRef, useEffect, useState } from 'react';

const Navigation = ({ activeTab, setActiveTab, isAdmin }) => {
    const navRef = useRef(null);
    const [showScrollIndicator, setShowScrollIndicator] = useState(false);

    // Проверка необходимости индикатора прокрутки
    useEffect(() => {
        const checkForScrollbar = () => {
            if (navRef.current) {
                // Если контент шире контейнера, нужен индикатор
                setShowScrollIndicator(
                    navRef.current.scrollWidth > navRef.current.clientWidth
                );
            }
        };

        // Проверяем при монтировании и при изменении размера окна
        checkForScrollbar();
        window.addEventListener('resize', checkForScrollbar);

        return () => {
            window.removeEventListener('resize', checkForScrollbar);
        };
    }, []);

    // Прокручиваем к активному табу
    useEffect(() => {
        if (navRef.current && activeTab) {
            // Находим активную кнопку
            const activeButton = navRef.current.querySelector(`button.active`);

            if (activeButton) {
                // Получаем положение элемента относительно родителя
                const buttonOffset = activeButton.offsetLeft;
                const buttonWidth = activeButton.offsetWidth;
                const navWidth = navRef.current.offsetWidth;

                // Прокручиваем, чтобы активный элемент был по центру, если возможно
                navRef.current.scrollLeft = buttonOffset - (navWidth / 2) + (buttonWidth / 2);
            }
        }
    }, [activeTab]);    return (
        <nav className="nav-minimal">
            <ul className="nav-pills" ref={navRef}>
                <li>
                    <button
                        className={`nav-pill ${activeTab === 'home' ? 'active' : ''}`}
                        onClick={() => setActiveTab('home')}
                    >
                        Главная
                    </button>
                </li>
                <li>
                    <button
                        className={`nav-pill ${activeTab === 'catalog' ? 'active' : ''}`}
                        onClick={() => setActiveTab('catalog')}
                    >
                        Каталог
                    </button>
                </li>
                <li>
                    <button
                        className={`nav-pill ${activeTab === 'services' ? 'active' : ''}`}
                        onClick={() => setActiveTab('services')}
                    >
                        Услуги
                    </button>
                </li>
                <li>
                    <button
                        className={`nav-pill ${activeTab === 'about' ? 'active' : ''}`}
                        onClick={() => setActiveTab('about')}
                    >
                        О нас
                    </button>
                </li>
                <li>
                    <a
                        href="https://t.me/TransitLab_ru"
                        className="nav-pill telegram"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21.198 2.433a2.242 2.242 0 0 0-1.022.215l-16.5 7.5a2.25 2.25 0 0 0 .126 4.102l3.9 1.205 2.25 6a2.25 2.25 0 0 0 4.122.39l2.934-5.878 4.28 3.421a2.25 2.25 0 0 0 3.51-1.875l-3-16.5a2.247 2.247 0 0 0-1.6-1.58z"/>
                        </svg>
                        Telegram
                    </a>
                </li>
                {isAdmin && (
                    <li>
                        <button
                            className={`nav-pill admin ${activeTab === 'admin' ? 'active' : ''}`}
                            onClick={() => setActiveTab('admin')}
                        >
                            Админ
                        </button>
                    </li>
                )}
            </ul>
            {showScrollIndicator && <div className="nav-scroll-hint">→</div>}
        </nav>
    );
};

export default Navigation;
